import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format, differenceInWeeks } from 'date-fns';
import "./Statistics.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const formatDate = (date) => format(new Date(date), 'do MMMM yyyy');

const Statistics = () => {
    const [internshipData, setInternshipData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const fetchDataFromAPI = async () => {
        try {
          const response = await axios.get(`${API_BASE_URL}/internship/requests`);
          // Check if response.data is an array. If not, default to an empty array.
          const fetchedData = Array.isArray(response.data) ? response.data : [];

          const groupedData = fetchedData.reduce((acc, request) => {
            const key = request.companyName;
            if (!acc[key]) {
              acc[key] = {
                companyName: key,
                numPeople: 0,
                students: [],
                internshipDates: []
              };
            }
            acc[key].numPeople++;
            acc[key].students.push({ name: request.fullName, email: request.email });
            acc[key].internshipDates.push({ commencement: request.commencementDate, completion: request.completionDate });
            return acc;
          }, {});

          const formattedData = Object.values(groupedData);
          setInternshipData(formattedData);
          setLoading(false);
        } catch (error) {
          console.error('Error fetching data from API:', error);
          setLoading(false);
        }
      };

      fetchDataFromAPI();
    }, []);

    return (
      <div className='Intern-table-div'>
        <h1>Internship Data</h1>
        {loading ? (
          <span className='loader'>Loading...</span>
        ) : (
          <table className="internship-table">
            <thead>
              <tr>
                <th>Institution</th>
                <th>Number of Interns</th>
                <th>Student Name</th>
                <th>Email</th>
                <th>Internship Duration</th>
              </tr>
            </thead>
            <tbody>
              {internshipData.map((data, index) => (
                <tr key={`${data.companyName}-${index}`}>
                  <td>{data.companyName}</td>
                  <td>{data.numPeople}</td>
                  <td>
                    {data.students.map((student, studentIndex) => (
                      <div key={`${data.companyName}-${studentIndex}`}>
                        {student.name}
                      </div>
                    ))}
                  </td>
                  <td>
                    {data.students.map((student, studentIndex) => (
                      <div key={`${data.companyName}-${studentIndex}`}>
                        <a href={`mailto:${student.email}`}>{student.email}</a>
                      </div>
                    ))}
                  </td>
                  <td>
                    {data.internshipDates.map((date, dateIndex) => (
                      <div className='Duration-span' key={`${data.companyName}-${dateIndex}`}>
                        {`${formatDate(date.commencement)} to ${formatDate(date.completion)} (${differenceInWeeks(new Date(date.completion), new Date(date.commencement)) + 1} weeks duration)`}
                      </div>
                    ))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  };
  
  export default Statistics;